import { useRouter } from "next/router";
import React, { useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import Heading from "../../components/Heading";
import collectionModel from "../../models/collections.model";

import helper from "../../lib/helper";
import _ from "lodash";
import Link from "next/link";
import { Card } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import productsModel from "../../models/products.model";
import autoComplete from "../../lib/autoComplete";

const Page = function () {
  const [showLoader, setShowLoader] = useState(false);
  const [preview, setPreview] = useState(
    "http://ssl.gstatic.com/accounts/ui/avatar_2x.png"
  );
  const [productItems, setproductItems] = useState("");

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
    setError,
    control,
  } = useForm({
    defaultValues: {
      condition_type: "any",
      condition_method: "automatic",
      conditions: [{ type: "", condition: "", value: [] }],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "conditions",
  });

  const router = useRouter();



  const onSelectFile = (e) => {
    const objectUrl = URL.createObjectURL(e.target.files[0]);
    setPreview(objectUrl);
  };

  const onSubmit = handleSubmit(async (data, event) => {
    const formData = new FormData(event.target);

    await collectionModel
      .create(formData)
      .then((response) => {
        helper.sweetalert.toast(response.data?.message, "success");
        router.push("/collections");
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  });

  return (
    <>
      <Heading title="Create Collections" showLoader={showLoader}>
        <Link className="btn btn-primary btn-sm" href={`/collections`}>
          <i className="bi bi-list" /> List
        </Link>
      </Heading>
      <form onSubmit={onSubmit} className="container-fluid">
        <div className="card col-md-12">
          <div className="card-header">Collection Creation Form </div>
          <div className="card-body row">
            <div className="col-md-2 col-6 me-3 position-relative border-end">
              <img src={preview} className="w-100 border rounded" alt="" />
              <div className="m-1">
                <label className="custom-file-upload">
                  <input
                    type="file"
                    className="d-none"
                    accept="image/*"
                    {...register("image", { onChange: onSelectFile })}
                  />
                  <b className="btn btn-dark">Upload</b>
                </label>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">Name</label>
              <input
                placeholder="Enter collection name"
                type="text"
                className={`form-control ${errors?.title && "is-invalid"}`}
                {...register("title", {
                  required: "Title is required",
                })}
              />
              <div className="invalid-feedback">{errors?.title?.message}</div>

              <div className="col mt-5">
                <label className="form-label">Condition_type:-</label>

                <input
                  type="radio"
                  value="all"
                  className="form-check-input mx-2"
                  {...register("condition_type", {
                    required: "Condition_type is required",
                  })}
                />
                <label className="form-check-label">All</label>

                <input
                  type="radio"
                  value="any"
                  className="form-check-input mx-2"
                  {...register("condition_type", {
                    required: "Condition_type is required",
                  })}
                />
                <label className="form-check-label">Any</label>
                <div className="invalid-feedback">
                  {errors?.condition_type?.message}
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">Status</label>
              <select
                className={`form-select ${errors?.status && "is-invalid"}`}
                {...register("status", {
                  required: "Status is required",
                })}
              >
                <option value="active">active</option>
                <option value="deactive">inactive</option>
              </select>
              <div className="invalid-feedback">
                {errors?.status?.message}
              </div>
              <div className="col mt-5">
                <label className="form-label">Condition_method:-</label>

                <input
                  type="radio"
                  value="manual"
                  className="form-check-input mx-1"
                  {...register("condition_method", {
                    required: "Condition_method is required",
                  })}
                />
                <label className="form-check-label">Manual</label>

                <input
                  type="radio"
                  value="automatic"
                  className="form-check-input mx-2"
                  {...register("condition_method", {
                    required: "Condition_method is required",
                  })}
                />
                <label className="form-check-label">Automatic</label>
                <div className="invalid-feedback">
                  {errors?.condition_method?.message}
                </div>
              </div>
            </div>
          </div>

          {/* Conditions / Products */}
          <div className="card-body row g-3">
            {watch("condition_method") === "automatic" ? (
              <>
                <Card.Header>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary float-end"
                    onClick={() =>
                      append({ type: "", condition: "", value: [] })
                    }
                  >
                    Add condition
                  </button>
                </Card.Header>
                <Card.Body>
                  {fields.map((field, index) => (
                    <div key={field.id} className="row g-3">
                      <div className="col-md-3">
                        <label className="form-label">Type</label>
                        <select
                          className={`form-select ${errors?.conditions?.[index]?.type && "is-invalid"
                            }`}
                          {...register(`conditions[${index}][type]`, {
                            required: true,
                          })}
                        >
                          <option value="">Select-type</option>
                          <option value="category">Category</option>
                          <option value="price">Price</option>
                          <option value="seller">Seller</option>
                          <option value="brands">Brands</option>
                          <option value="age">Age</option>
                          <option value="tags">Tags</option>
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Condition</label>
                        <select
                          className={`form-select ${errors?.conditions?.[index]?.condition &&
                            "is-invalid"
                            }`}
                          {...register(`conditions[${index}][condition]`, {
                            required: true,
                          })}
                        >
                          <option value="">Select condition</option>
                          <option value="between">Between</option>
                          <option value="equal">Equal</option>
                          <option value="greaterthan">Greater-than</option>
                          <option value="lesserthan">Lesser-than</option>
                        </select>
                      </div>

                      <div className="col-md-3">
                        {["price", "age"].includes(
                          watch(`conditions[${index}][type]`)
                        ) ? (
                          <div className="row">
                            <div className="col-md-6">
                              <label className="form-label">
                                {(watch(`conditions[${index}][type]`) === "price")
                                  ? "Min-price"
                                  : "Min-age"}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                {...register(`conditions[${index}][value][0]`)}
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label">
                                {(watch(`conditions[${index}][type]`) === "price")
                                  ? "Max-price"
                                  : "Max-age"}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                {...register(`conditions[${index}][value][1]`)}
                              />
                            </div>
                          </div>
                        ) : (
                          <>
                            <label className="form-label">Value</label>
                            {watch(`conditions[${index}][type]`) ===
                              "category" && (
                                <AsyncSelect
                                  name={`conditions[${index}][value]`}
                                  defaultOptions
                                  loadOptions={autoComplete.filterCategory}
                                  placeholder="Search here..."
                                  isClearable
                                  isMulti
                                />
                              )}
                            {watch(`conditions[${index}][type]`) === "brands" && (
                              <AsyncSelect
                                name={`conditions[${index}][value]`}
                                defaultOptions
                                loadOptions={autoComplete.filterBrands}
                                placeholder="Search here..."
                                isClearable
                                isMulti
                              />
                            )}
                            {watch(`conditions[${index}][type]`) === "tags" && (
                              <AsyncSelect
                                name={`conditions[${index}][value]`}
                                defaultOptions
                                loadOptions={autoComplete.filterTags}
                                placeholder="Search here..."
                                isClearable
                                isMulti
                              />
                            )}
                            {watch(`conditions[${index}][type]`) === "seller" && (
                              <AsyncSelect
                                name={`conditions[${index}][value]`}
                                defaultOptions
                                loadOptions={autoComplete.filterSeller}
                                placeholder="Search here..."
                                isClearable
                                isMulti
                              />
                            )}
                          </>
                        )}
                      </div>
                      <div className="col-md-3">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary mt-4 float-end"
                          onClick={() => remove(index)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </Card.Body>
              </>
            ) : (
              <>
                <Card.Header>Search products</Card.Header>
                <AsyncSelect
                  name="products_ids[]"
                  defaultOptions
                  loadOptions={autoComplete.filterProducts}
                  placeholder="Search here..."
                  isClearable
                  isMulti
                />
              </>
            )}
          </div>

          {/* SEO */}
          <Card.Header>SEO</Card.Header>
          <Card.Body>
            <div className="col-md-12">
              <label className="form-label">Meta-title</label>
              <input
                type="text"
                className={`form-control ${errors?.meta?.title && "is-invalid"}`}
                {...register("meta[title]")}
              />
              <div className="invalid-feedback">
                {errors?.meta?.title?.message}
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <label className="form-label">Meta-description</label>
              <textarea
                className={`form-control ${errors?.meta?.description && "is-invalid"
                  }`}
                {...register("meta[description]")}
              />
              <div className="invalid-feedback">
                {errors?.meta?.description?.message}
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <label className="form-label">Meta-keywords</label>
              <input
                type="text"
                className={`form-control ${errors?.meta?.keywords && "is-invalid"
                  }`}
                {...register("meta[keywords]")}
              />
              <div className="invalid-feedback">
                {errors?.meta?.keywords?.message}
              </div>
            </div>
          </Card.Body>

          <div className="card-footer">
            <button
              type="submit"
              disabled={isSubmitting}
              className="btn btn-primary float-end"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default Page;
